var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dsfa-sc-common-tools"},[_c('DsfSCPanel',{attrs:{"title":"常用功能","more":true,"setting":true}},[_c('div',{staticClass:"dsfa-sc-common-tools-content"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"dsfa-sc-common-tools-block",on:{"click":function($event){return _vm.toUrl(item)}}},[_c('div',{staticClass:"dsfa-sc-common-tools-block-content"},[_c('i',{class:[
              'dsfa-sc-common-tools-block-content-icon',
              'icon',
              'iconfont',
              item.icon,
            ]}),_c('div',{staticClass:"dsfa-sc-common-tools-block-content-text"},[_vm._v(" "+_vm._s(item.text)+" ")])])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }